import { Breakpoints, Layout, LayoutConfiguration, styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useRef, useState } from 'react';
import { CarlineContext, useFeatureAppConfig, useMaxWidthFunc } from 'src/feature-app/hooks';
import { CarlineWithOffers, Offer } from 'src/types';
import {
  VerComparadorCTA,
  CloseOferCTA,
  CarlineOffer,
  DesktopOfferContainer,
  MoreEquipmentButton,
} from 'src/components';
import { CSSTransition } from 'react-transition-group';
import { MofaCarousel } from '../MofaCarousel/MofaCarousel';
import { useElementWidth } from '../MofaCarousel/use-element-width';
import { TrimSelectionColumn, useSlider, useViewportWidth } from '../MofaCarousel';
import { getVisibleTrimSelectionColumnCount } from '../MofaCarousel/get-visible-trim-selection-column-count';
import { isCommercial } from 'src/bff/get-data-url';
import { getDataServiceConfig } from '../save-feature-app';
import { CarlineOfferCampaign } from 'src/components/CarlineOfferCampaign';

interface DesktopOfferProps {
  carline: CarlineWithOffers;
  setShowOfferToFalse: () => void;
  unSelectCarline?: () => void;
  offersId: string;
  auxDesktopOfferClassName: string;
  showCard: boolean;
}

const oneOffer: LayoutConfiguration = {
  [Breakpoints.default]: [{ name: 'a', columns: 24 }],
};

const twoOffers: LayoutConfiguration = {
  [Breakpoints.default]: [
    { name: 'a', columns: 6 },
    { name: '.', columns: 3 },
    { name: 'b', columns: 6 },
    { name: '.', columns: 3 },
    { name: 'c', columns: 6 },
  ],
  [Breakpoints.b960]: [
    { name: '.', columns: 5 },
    { name: 'a', columns: 6 },
    { name: '.', columns: 2 },
    { name: 'b', columns: 6 },
    { name: '.', columns: 5 },
  ],
};

const threeOffers: LayoutConfiguration = {
  [Breakpoints.default]: [
    { name: 'a', columns: 6 },
    { name: '.', columns: 3 },
    { name: 'b', columns: 6 },
    { name: '.', columns: 3 },
    { name: 'c', columns: 6 },
  ],
  [Breakpoints.b960]: [
    { name: '.', columns: 2 },
    { name: 'a', columns: 6 },
    { name: '.', columns: 1 },
    { name: 'b', columns: 6 },
    { name: '.', columns: 1 },
    { name: 'c', columns: 6 },
    { name: '.', columns: 1 },
  ],
};
export const OfferViewDesktop = (props: DesktopOfferProps) => {
  const { carline, setShowOfferToFalse, unSelectCarline, offersId, auxDesktopOfferClassName } = props;

  const config = useFeatureAppConfig();

  const numberOfOffers = carline.ofertasCampaign
    ? carline.ofertas.length + carline.ofertasCampaign.length
    : carline.ofertas.length;

  const [activeComparador, setActiveComparador] = useState(numberOfOffers === 1 ? true : false); // Equipamiento activo por defecto si solo hay una oferta
  const [offerChange, setOfferChange] = useState<boolean>(true);
  const [ofertas, setOfertas] = useState(carline.ofertas);
  const [activeTrimIndex, setActiveTrimIndex] = useState(0);
  //carousel
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(numberOfOffers === 1 ? carline.ofertas[0] : null);

  const offerContainerRef = useRef<any>(null);
  const [sliderWidth, sliderElementRef] = useElementWidth();
  const viewportWidth = useViewportWidth();
  const offsetHasBeenChanged = React.useRef(false);
  const dataService = getDataServiceConfig();

  const visibleSlideCount = getVisibleTrimSelectionColumnCount(viewportWidth);
  const { useMaxWidth } = useMaxWidthFunc(numberOfOffers);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (offerContainerRef && offerContainerRef.current) {
        if (config.mode !== 'filter' && (!activeComparador || numberOfOffers === 1)) {
          offerContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 200);

    return () => clearTimeout(timeout);
  }, [offerChange, activeComparador]);

  useEffect(() => {
    setOfferChange(false);
    if (numberOfOffers !== 1) setActiveComparador(false);
    const timer = setTimeout(() => {
      setOfferChange(true);
    }, 0);
    const timer2 = setTimeout(() => {
      setOfertas(carline.ofertas);
    }, 400);
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, [carline]);

  useEffect(() => setOfertas(carline.ofertas), []);

  const slider = useSlider({
    sliderWidth,
    offset: activeTrimIndex,
    totalSlideCount: numberOfOffers,
    visibleSlideCount,

    onOffsetChange: React.useCallback(
      (newOffset, direction) => {
        offsetHasBeenChanged.current = true;
        // setActiveTrimIndex(newOffset);
        setActiveTrimIndex(newOffset);
      },
      [setActiveTrimIndex]
    ),
  });

  return (
    <CSSTransition timeout={400} in={offerChange} classNames="offers">
      <DesktopOfferContainer
        ref={offerContainerRef}
        numberOfOffers={numberOfOffers}
        isOverview={config.mode !== 'filter'}
        id={offersId}
        className={auxDesktopOfferClassName}
        useMaxWidth={useMaxWidth}
      >
        <h1 style={{ textAlign: 'center' }}>
          Ofertas {carline.nuevo ? 'Nuevo' : null} {carline.title}
        </h1>
        {config.mode !== 'filter' ? (
          <CloseOferCTA setShowOfferToFalse={setShowOfferToFalse} unSelectCarline={unSelectCarline} />
        ) : null}
        {numberOfOffers < 4 ? (
          <>
            <CarlineContext.Provider value={props.carline}>
              <Layout appearance={numberOfOffers === 1 ? oneOffer : numberOfOffers === 2 ? twoOffers : threeOffers}>
                {carline.ofertasCampaign && (
                  <CarlineOfferCampaign
                    offer={ofertas[0]}
                    activeComparador={false}
                    numberOfOffers={numberOfOffers}
                    showCard={false}
                    setSelectedOffer={setSelectedOffer}
                    offerNumber={0}
                    setShowOfferToFalse={setShowOfferToFalse}
                    unSelectCarline={unSelectCarline}
                  />
                )}
                {ofertas.map((oferta, i) => {
                  return (
                    <CarlineOffer
                      offer={oferta}
                      activeComparador={numberOfOffers === 1 ? true : activeComparador}
                      numberOfOffers={numberOfOffers}
                      offerChange={offerChange}
                      offerNumber={i + 1}
                      key={`${i}-${oferta.carlineTitle}`}
                      showCard={false}
                      setShowOfferToFalse={setShowOfferToFalse}
                      unSelectCarline={unSelectCarline}
                    />
                  );
                })}
              </Layout>
            </CarlineContext.Provider>
            {!isCommercial(dataService) ? (
              <VerComparadorCTA
                numberOfOffers={numberOfOffers}
                setActive={setActiveComparador}
                active={activeComparador}
                model={carline}
              />
            ) : (
              <MoreEquipmentButton
                numberOfOffers={numberOfOffers}
                activeEquipment={activeComparador}
                setActiveEquipment={setActiveComparador}
                model={carline}
              />
            )}
          </>
        ) : (
          <CarlineContext.Provider value={props.carline}>
            <MofaCarousel
              sliderElementRef={sliderElementRef}
              onPrevious={slider.previous}
              onNext={slider.next}
              paginationHasBeenUsed={offsetHasBeenChanged.current}
            >
              {carline.ofertasCampaign && (
                <>
                  <TrimSelectionColumn
                    key={0}
                    index={0}
                    bindGestureHandlers={slider.bindGestureHandlers}
                    spring={slider.springs[0]}
                    onFocusInvisible={() => setActiveTrimIndex(-1)}
                  >
                    <CarlineOfferCampaign
                      offer={ofertas[0]}
                      activeComparador={false}
                      numberOfOffers={numberOfOffers}
                      showCard={false}
                      setSelectedOffer={setSelectedOffer}
                      offerNumber={0}
                      setShowOfferToFalse={setShowOfferToFalse}
                      unSelectCarline={unSelectCarline}
                    />
                  </TrimSelectionColumn>
                </>
              )}
              {carline.ofertas.map((offer, index) => {
                return (
                  <TrimSelectionColumn
                    key={carline.ofertasCampaign ? index + 2 : index}
                    index={carline.ofertasCampaign ? index + 1 : index}
                    bindGestureHandlers={slider.bindGestureHandlers}
                    spring={slider.springs[carline.ofertasCampaign ? index + 1 : index]}
                    onFocusInvisible={() => setActiveTrimIndex(index)}
                  >
                    <CarlineOffer
                      offer={offer}
                      activeComparador={activeComparador}
                      numberOfOffers={numberOfOffers}
                      showCard={false}
                      setSelectedOffer={setSelectedOffer}
                      offerNumber={index + 1}
                      key={`${offer.anchor}-${index}-c`}
                      setShowOfferToFalse={setShowOfferToFalse}
                      unSelectCarline={unSelectCarline}
                    />
                  </TrimSelectionColumn>
                );
              })}
            </MofaCarousel>
            {setActiveComparador ? (
              <VerComparadorCTA
                numberOfOffers={numberOfOffers}
                setActive={setActiveComparador}
                active={activeComparador}
                model={carline.ofertas[0]} // Info para el tracking
              />
            ) : null}
          </CarlineContext.Provider>
        )}
      </DesktopOfferContainer>
    </CSSTransition>
  );
};
